/* @flow */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// $FlowIgnore
import Modal from 'react-modal';

import Row from 'components/UIKit/Flex/Row';
import Button from 'components/UIKit/Button/Button';
import UploadContainer from 'containers/UploadContainer';

let modalStyles = {
  overlay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    position: 'absolute',
    bottom: 'auto',
    right: 'auto',
    left: 'calc((100% - 48rem) / 2)',
    top: 'calc((100% - 38rem) / 2)',
    width: '48rem',
    height: '38rem',
  }
};

export default class UploadButton extends Component {
  static propTypes = {
    params: PropTypes.shape({
      program: PropTypes.string,
      project: PropTypes.string,
    }),
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object
    }),
    style: PropTypes.object,
  };

  // $FlowIgnore
  state: Object = { modalIsOpen: false };
  // $FlowIgnore
  openModal = () => this.setState({ modalIsOpen: true });
  // $FlowIgnore
  closeModal = () => this.setState({ modalIsOpen: false });

  render(): React.Element {
    let { modalIsOpen } = this.state;
    let { style, disabled, children } = this.props;

    return (
      <Row data-testid="button-upload">
        <Button
          style={style}
          onClick={this.openModal}
          disabled={disabled}
        >
          {disabled ? 'Upload disabled' : children || 'Upload'}
        </Button>
        <Modal
          style={modalStyles}
          closeTimeoutMS={150}
          isOpen={modalIsOpen}
          onRequestClose={() => {}}
        >
          <UploadContainer {...this.props} closeModal={this.closeModal} />
        </Modal>
      </Row>
    );
  }
}
